import { useState } from 'react';
import { FiCopy } from 'react-icons/fi';

async function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
}

export default function ShareButton({ textToCopy }) {
  const [status, setStatus] = useState('');

  async function handleCopy() {
    try {
      await copyToClipboard(textToCopy);
      setStatus('Copied');
    } catch {
      setStatus('Failed');
    }

    setTimeout(() => setStatus(''), 1500);
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="elevated inline-flex items-center gap-2 rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-sm font-semibold text-brand-text"
      aria-label="Copy result summary"
      title="Copy result summary"
    >
      <FiCopy size={16} />
      {status || 'Share Result'}
    </button>
  );
}
